export default __webpack_public_path__ + "static/media/151-domestic-phone.60e14fa4.png";